import CryptoJS from "crypto-js";

/**
 * Tạo chữ ký HMAC cho request
 */
export function createHmacSignature({
    method,
    url,
    timestamp,
    body,
    secret,
}) {
    const m = method.toUpperCase();

    const normalizedBody =
        m === "GET" || m === "DELETE"
            ? ""
            : body && typeof body === "object" && Object.keys(body).length > 0
                ? JSON.stringify(body)
                : "";

    const payload = [
        method.toUpperCase(),
        url,
        timestamp,
        normalizedBody,
    ].join("|");

    // console.log("🔐 CLIENT PAYLOAD:", payload);

    return CryptoJS.HmacSHA256(payload, secret).toString(
        CryptoJS.enc.Hex
    );
}

export function createHmacSignatureStreamVideo({
    method,
    fileId,
    timestamp,
    secret,
}) {


    const payload = [
        method.toUpperCase(),
        fileId,
        timestamp,
    ].join("|");

    // console.log("🔐 CLIENT PAYLOAD:", payload);

    return CryptoJS.HmacSHA256(payload, secret).toString(
        CryptoJS.enc.Hex
    );
}